import { render } from "./InternalBroadcastBanner.vue?vue&type=template&id=3c63fed1"
import script from "./InternalBroadcastBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalBroadcastBanner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/InternalBroadcastBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c63fed1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c63fed1', __exports__)) {
    api.reload('3c63fed1', __exports__)
  }
  
  module.hot.accept("./InternalBroadcastBanner.vue?vue&type=template&id=3c63fed1", () => {
    api.rerender('3c63fed1', render)
  })

}


export default __exports__